import React, { useState, useEffect, useContext } from 'react'
import { CheckCircleFill, ExclamationCircleFill } from 'react-bootstrap-icons';
import { Card, Container, Row, Col, Alert, Form, FormGroup, InputGroup, Button } from 'react-bootstrap'
import AuthContext from '../../../context/AuthProvider'
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';


//pwd regular expression
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W|_]).{8,}$/


export default function ResetPassword() {
    const navigate = useNavigate()
    const location = useLocation()
    const {auth, setAuth} = useContext(AuthContext)
    const [isMounted, didMount] = useState(false)
    const [loading, isLoading] = useState(true)
    const [errMsg, setErrMsg] = useState('')
    const [newPwd, setNewPwd] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [matchNewPwd, setMatchPwd] = useState('')
    const [pwdMatch, setPwdMatch] = useState(false)
    const [validPwd, setValidPwd] = useState(false)
    const [registrationType, setRegistrationType] = useState(location.state.registrationType || null)
    const [userEmail, setUserEmail] = useState( location.state.email || null)
    
    useEffect(()=> {
        didMount(true)
        if (registrationType == null || userEmail == null) {
            navigate('/login', { replace: true })
        }

    }, [])

    useEffect(()=> {
        if (isMounted) {
            isLoading(false)
        }
    }, [isMounted])
    
    
    useEffect(()=> {
        if (newPwd != '') {
            if (!PWD_REGEX.test(newPwd)) {
                setErrMsg("Password is not valid")
                setValidPwd(false)
            } else {
                setErrMsg("")
                // if password is valid, check if they match
                setValidPwd(true)

                if (matchNewPwd != '') {
                    if (newPwd == matchNewPwd) {
                        setPwdMatch(true)
                        setErrMsg('')
                    } else {
                        //pwds do not match
                        setPwdMatch(false)
                        setErrMsg("Passwords do not match")
                    }
                } else {
                    //pwd match field empty, therefore pwds do not match
                    setPwdMatch(false)
                    setErrMsg("Passwords do not match")
                }
            }
        } else {
            setErrMsg("")
        }

    }, [newPwd, matchNewPwd])



    const onSubmit = async (e) => {
        e.preventDefault()

        //1. if valid pwd
        if (validPwd && pwdMatch) {
            //2. api post to back and change pwd
           await axios.post("/user/change-password", { newPassword: newPwd  , userEmail })
                .then ((res)=> {
                    const data = res.data;
                    if (data.success == true ) {
                        // succussfully changed password
                        console.log("Successfully changed user password")

                        // start user login session
                        
                        sessionStorage.removeItem("registrationType")
                        sessionStorage.setItem("passwordChanged", true)
                        //navigate to login page
                        navigate('/login?passwordChanged=true', { replace: true })

                    } else {
                        setErrMsg(res.data.message)
                    }
                }).catch( (error) => {
                    setErrMsg("We apologize for the inconvenience, but an error has occurred on our end. Please attempt to reset your password at a later time.")
                })

        } else {
            setErrMsg("Password is not valid.")
        }
    }
    if (!loading) return (
        <Container className='mt-15vh'>
            <Row className='justify-content-center'>
                <Col sm={10} md={6} className='mx-auto mw-500'>
                        <Alert variant='danger' className={ errMsg == ''? ("hide"):("show")} >
                            { errMsg }
                        </Alert>

                        <Card>
                            <Card.Header> Reset Password</Card.Header>

                            <Card.Body>
                                <Form onSubmit={onSubmit} >

                                    <Alert variant='primary'>
                                        To access your verified account, you will need to create a new password.
                                    </Alert>

                                    <FormGroup className='mb-3'>
                                        <Form.Label> Email </Form.Label>
                                        <Form.Control 
                                        type="email"
                                        placeholder={ userEmail }
                                        disabled/>
                                    </FormGroup>


                                    <FormGroup className='mb-3'>
                                        <Form.Label> New Password  </Form.Label>
                                        <Form.Control 
                                            type={showPassword ? "text" : "password"}
                                            value={newPwd}
                                            onChange={e=> setNewPwd(e.target.value)}
                                            required
                                        />
                                    </FormGroup>

                                    <FormGroup className='mb-3'>
                                        <Form.Label> Confirm Password </Form.Label>
                                        <Form.Control 
                                            type={showPassword ? "text" : "password"}
                                            value={matchNewPwd}
                                            onChange={e=> setMatchPwd(e.target.value)}
                                            required
                                        />
                                    </FormGroup>
                                    <Form.Check 
                                        type="checkbox"
                                        label="Show Password"
                                        onChange={e=> setShowPassword(e.target.checked)}
                                    />

                                    <Alert variant="warning" className= { !validPwd? ("show"): ("hide")}>
                                            <small>
                                                <ul>
                                                    <li>The password must be at least 8 characters long</li>
                                                    <li> The password must contain at least one lowercase letter, one uppercase letter, one digit, and one special character.</li>
                                                </ul>
                                            </small>
                                    </Alert>

                                    <div className='mt-3'>

                                        <Button type="sumbit" 
                                            disabled = {!validPwd || !pwdMatch? true: false} 
                                            className="mr-2"
                                            style={{ float: "right", color: 'white'}}> 
                                            Change Password
                                        </Button>
                                    </div>

                                    
                                </Form>
                            </Card.Body>
                        </Card>

                </Col>
            </Row>
        </Container>

    )
}